import {
  AccordionItem,
  AccordionButton,
  Box,
  AccordionIcon,
  AccordionPanel,
  Text,
  TextProps,
  Flex,
} from "@chakra-ui/react";
import React, { ReactNode } from "react";

export type TAccordianItemWrapper = {
  prefixLabel?: string;
  label: string;
  element: ReactNode;
  labelStyle?: TextProps;
};
const AccordianItemWrapper = ({
  prefixLabel,
  label,
  element,
  labelStyle,
}: TAccordianItemWrapper) => {
  return (
    <AccordionItem border={"none"}>
      <AccordionButton
        px="0"
        _hover={{
          borderRadius: { base: "16px", lg: "24px" },
        }}
      >
        <Box as="span" flex="1" textAlign="left">
          <Flex gap={1}>
            {prefixLabel && (
              <Text fontSize={"14px"} fontWeight={600} lineHeight="21px">
                {prefixLabel}{" "}
              </Text>
            )}
            <Text
              fontSize={"14px"}
              fontWeight={500}
              lineHeight="21px"
              {...(labelStyle || {})}
            >
              {label}
            </Text>
          </Flex>
        </Box>
        <AccordionIcon />
      </AccordionButton>

      <AccordionPanel pb={{ base: "12px", lg: "1.5rem " }} px="0">
        {element}
      </AccordionPanel>
    </AccordionItem>
  );
};

export default AccordianItemWrapper;
